import { Component, Fragment } from "react";
import { compose } from "redux";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";

import _ from "underscore";
import ClaimsWrapper from "../../../../shared/ui/Claim.Wrapper";

import { withdrawalConnector } from "../../../../services/users/withdrawal/connector";
import {
  allClaimsOtherThanAml,
  fundManager,
} from "../../../../shared/ClaimLists/Claim.Aml.All.List";
import { FormControlLabel } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";

class WithdrawalComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      SelectedBankAccount: "",
      SelectedDepot: null,
      SelectedDepotId: null,
      WithdrawalAmount: 0,
      IsSalesPerformanceExcluded: false,
      firstSet: false,
    };
  }

  componentDidMount() {
    if (
      this.props.depot.fetched &&
      this.props.depot.data[this.props.accountId] &&
      !this.state.firstSet
    ) {
      this.setDefaultDepot(this.props);
    }
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    if (
      this.props.orders.sending === true &&
      props.orders.sending === false &&
      props.orders.sent === true
    ) {
      this.setState({
        ...this.state,
        Sent: true,
      });
    }

    if (
      props.depot.fetched &&
      props.depot.data[this.props.accountId] &&
      !this.state.firstSet
    ) {
      this.setDefaultDepot(this.props);
    }
  };

  setDefaultDepot = (props) => {
    let depot,
      depots = props.depot.data;
    for (let i = 0; i < depots.length; i++) {
      if (!depots[i].Name) {
        depot = depots[i];
        this.setState({
          SelectedDepot: depot,
          SelectedDepotId: depot.Id,
          firstSet: true,
        });
        break;
      }
    }
  };

  handleSelectChange = (event) => {
    this.setState({
      ...this.state,
      SelectedBankAccount: event.target.value,
    });
  };

  handleSelectDepotChange = (event) => {
    let selectedDepotId = event.target.value;
    let selectedDepot = _.find(
      this.props.depot.data[this.props.accountId],
      (item) => {
        return item.Id === selectedDepotId;
      },
    );

    this.setState({
      ...this.state,
      SelectedDepotId: selectedDepotId,
      SelectedDepot: selectedDepot,
    });
  };

  handleAmountChange = (event) => {
    this.setState({
      ...this.state,
      WithdrawalAmount: event.target.value,
    });
  };

  handleIsSalesPerformanceExcludedChange = (event) => {
    this.setState({
      ...this.state,
      IsSalesPerformanceExcluded: event.target.checked,
    });
  };

  buildBankAccountItems = () => {
    var bankAccountsData = this.props.users.currentUser.BankAccounts;

    return bankAccountsData.map((item) => {
      return (
        <MenuItem key={item.Id} value={item.Id}>
          {item.Number ? item.Number : item.HolderName}{" "}
        </MenuItem>
      );
    });
  };

  buildDepotItems = () => {
    var depotData = this.props.depot.data[this.props.accountId];

    return depotData.map((item) => {
      return (
        <MenuItem key={item.Id} value={item.Id}>
          {item.Name ? item.Name : "Primary"}
        </MenuItem>
      );
    });
  };

  createWithdrawal = () => {
    this.props.placeWithdrawal(
      this.state.WithdrawalAmount,
      this.state.SelectedBankAccount,
      this.state.SelectedDepotId,
      this.state.IsSalesPerformanceExcluded,
    );
  };
  createForceWithdrawal = () => {
    this.props.placeForceWithdrawal(
      this.state.WithdrawalAmount,
      this.state.SelectedBankAccount,
      this.state.SelectedDepotId,
      this.state.IsSalesPerformanceExcluded,
    );
  };
  createMegaForceWithdrawal = () => {
    this.props.placeMegaForceWithdrawal(
      this.state.WithdrawalAmount,
      this.state.SelectedBankAccount,
      this.state.SelectedDepotId,
      this.state.IsSalesPerformanceExcluded,
    );
  };

  render = () => {
    if (
      !this.props.depot.fetched ||
      !this.props.depot.data[this.props.accountId]
    )
      return <Fragment />;

    return (
      <div style={{ marginTop: "50px" }}>
        <h4>Withdrawal order placement</h4>
        <hr style={{ marginBottom: "0px" }} />
        <TextField
          size="small"
          variant="outlined"
          select
          label={"Choose depot"}
          underlineStyle={{ borderColor: "rgb(64, 192, 87)" }}
          value={this.state.SelectedDepotId}
          fullWidth={true}
          onChange={this.handleSelectDepotChange}
        >
          {this.buildDepotItems()}
        </TextField>
        <br />
        Total capital:{" "}
        {this.state.SelectedDepot ? this.state.SelectedDepot.Value.Amount : 0}
        {this.state.SelectedDepot?.Currency} <br />
        Balance to withdraw:{" "}
        {this.state.SelectedDepot ? this.state.SelectedDepot.Balance.Amount : 0}
        {this.state.SelectedDepot?.Currency} <br />
        <TextField
          size="small"
          variant="outlined"
          select
          label={"Choose bank account"}
          underlineStyle={{ borderColor: "rgb(64, 192, 87)" }}
          value={this.state.SelectedBankAccount}
          fullWidth={true}
          onChange={this.handleSelectChange}
        >
          {this.buildBankAccountItems()}
        </TextField>
        <br />
        <TextField
          size="small"
          variant="outlined"
          value={this.state.WithdrawalAmount}
          onChange={this.handleAmountChange}
          fullWidth={true}
          label="Amount"
        />
        <br />
        <FormControlLabel
          control={
            <Checkbox
              checked={this.state.IsSalesPerformanceExcluded}
              onClick={this.handleIsSalesPerformanceExcludedChange}
            />
          }
          label="Exclude from Sales performance"
        />
        <br />
        {this.props.orders.sending ||
        this.props.forceOrder.sending ||
        this.props.megaForceOrder.sending ? (
          <CircularProgress />
        ) : (
          <Fragment>
            <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
              <Button
                variant="contained"
                color="primary"
                onClick={this.createWithdrawal}
              >
                Create withdrawal
              </Button>
            </ClaimsWrapper>
            <ClaimsWrapper requiredClaims={fundManager}>
              <Button
                variant="contained"
                color="primary"
                onClick={this.createForceWithdrawal}
              >
                Create withdrawal (force)
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={this.createMegaForceWithdrawal}
              >
                Create withdrawal (mega force)
              </Button>
            </ClaimsWrapper>
          </Fragment>
        )}
        {(this.props.orders.sent === true ||
          this.props.forceOrder.sent === true ||
          this.props.megaForceOrder.sent === true) && <strong>Sent</strong>}
      </div>
    );
  };
}
export default compose(withdrawalConnector)(WithdrawalComponent);
